import { AnimatePresence, motion } from 'framer-motion'
import * as React from 'react'
import { fillAnimationVariants } from '../../../Data/Data'
import { LightColorName } from '../../../Data/Types'

interface ResultsVirtualLinesProps {
	lines: 1 | 2
	projectors: 1 | 2
	color: LightColorName
}
const viewBoxWidth = 137.27
const viewBoxHeight = 62.459999
const ResultsVirtualLines: React.FC<ResultsVirtualLinesProps> = ({
	lines,
	projectors,

	color,
}) => (
	<svg
		viewBox={`0 0 ${
			projectors === 1 ? viewBoxWidth * 0.6 : viewBoxWidth
		} ${viewBoxHeight}`}
		xmlns="http://www.w3.org/2000/svg"
	>
		<title>{'VirtualLineResult'}</title>
		<g
			data-name="Layer 2"
			style={{
				isolation: 'isolate',
			}}
		>
			<g data-name="Layer 1">
				<AnimatePresence>
					{projectors === 2 && (
						<motion.g
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							data-name="2projectors"
						>
							<g data-name="bg1">
								<path
									style={{
										fill: '#bebec0',
									}}
									d="m82.16 56.48 55.11-3.53-26.66-8.16-55.5 3.46z"
									data-name="LWPOLYLINE"
								/>
								<path
									style={{
										fill: '#969697',
									}}
									d="m55.39 27.57 55.49-3.46v20.72l-55.49 3.46z"
									data-name="LWPOLYLINE"
								/>
								<motion.path
									animate={color}
									variants={fillAnimationVariants}
									style={{
										opacity: 0.15,
									}}
									d="M79.83 55.84 91.8 1.99l43.5 50.85z"
								/>
								<path
									style={{
										fill: 'none',
										stroke: '#77787b',
										strokeWidth: '.75px',
										strokeMiterlimit: 10,
										strokeDasharray: 5,
									}}
									d="M91.73 1.65v48.03"
								/>
								<path
									style={{
										fill: '#ec1c24',
									}}
									d="M90.13 0h3.2v3.69h-3.2z"
								/>
								<path
									style={{
										fill: 'none',
										stroke: '#77787b',
										strokeWidth: '.75px',
										strokeMiterlimit: 10,
										strokeDasharray: 5,
									}}
									d="m85.19 46.64 6.49 3.04"
								/>
							</g>
							{lines === 2 && (
								<motion.g
									data-name="bg2"
									initial={{ opacity: 0 }}
									animate={{ opacity: 1 }}
									exit={{ opacity: 0 }}
								>
									<AnimatePresence>
										<motion.path
											animate={{ opacity: 1 }}
											initial={{ opacity: 0 }}
											exit={{ opacity: 0 }}
											style={{
												fill: '#ec1c24',
											}}
											d="M86.23 1.52h3.2v3.69h-3.2z"
										/>
									</AnimatePresence>
									<motion.path
										animate={color}
										variants={fillAnimationVariants}
										style={{
											opacity: 0.15,
										}}
										d="M60.46 49.06 87.83 3.9l24.63 42.11z"
									/>
								</motion.g>
							)}
							<motion.path
								variants={fillAnimationVariants}
								animate={color}
								d="m80.55 56.05 55.55-3.46-2.14-.65-55.73 3.43z"
								data-name="line1"
							/>
							<AnimatePresence>
								{lines === 2 && (
									<motion.path
										variants={fillAnimationVariants}
										animate={color}
										exit={{ opacity: 0 }}
										d="m59.86 49.8 56.5-3.26-2.14-.66-56.68 3.25z"
										data-name="line2"
									/>
								)}
							</AnimatePresence>
						</motion.g>
					)}
				</AnimatePresence>
				<g data-name="1projector">
					<g data-name="bg1">
						<path
							style={{
								fill: '#969697',
							}}
							d="m0 31.06 55.49-3.46v20.72L0 51.77z"
							data-name="LWPOLYLINE"
						/>
						<path
							transform="rotate(-3.22 52.972 59.883)"
							style={{
								fill: '#231f20',
							}}
							d="M26.98 59.64h52.03v.46H26.98z"
						/>
						<path
							style={{
								fill: '#231f20',
							}}
							d="m27.29 60.16.13 2.3-2.05-1.04zM78.57 57.28l.13 2.3 1.92-1.26z"
						/>
						<path
							style={{
								fill: '#bebec0',
							}}
							d="m26.84 59.67 55.32-3.19-26.67-8.16L0 51.77z"
							data-name="LWPOLYLINE"
						/>
						<motion.path
							variants={fillAnimationVariants}
							animate={color}
							style={{
								opacity: 0.15,
							}}
							d="M23.31 58.95 35.28 5.11l43.49 50.85z"
						/>
						<path
							style={{
								fill: 'none',
								stroke: '#77787b',
								strokeWidth: '.75px',
								strokeMiterlimit: 10,
								strokeDasharray: 5,
							}}
							d="M35.9 4.77V52.8"
						/>
						<path
							style={{
								fill: '#ec1c24',
							}}
							d="M34.3 3.12h3.2v3.69h-3.2z"
						/>
						<path
							style={{
								fill: 'none',
								stroke: '#77787b',
								strokeWidth: '.75px',
								strokeMiterlimit: 10,
								strokeDasharray: 5,
							}}
							d="m29.35 49.76 6.5 3.04"
						/>
						<path
							style={{
								fill: '#231f20',
							}}
							d="M29.47 7.8v41.66M29.24 9.46h.46v38.35h-.46z"
						/>
						<path
							style={{
								fill: '#231f20',
							}}
							d="M30.63 9.79h-2.31l1.16-1.99zM30.63 47.47h-2.31l1.16 1.99z"
						/>
					</g>
					<AnimatePresence>
						{lines === 2 && (
							<motion.g
								data-name="bg2"
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0 }}
							>
								<path
									style={{
										fill: '#ec1c24',
									}}
									d="M30.29 5.11h3.2V8.8h-3.2z"
								/>
								<motion.path
									variants={fillAnimationVariants}
									animate={color}
									style={{
										opacity: 0.15,
									}}
									d="M4.52 52.65 31.89 7.49l28.75 42.06z"
								/>
							</motion.g>
						)}
					</AnimatePresence>

					<motion.path
						variants={fillAnimationVariants}
						animate={color}
						d="m25.45 59.21 55.32-3.19-2.14-.65-55.49 3.16z"
						data-name="line1"
					/>
					<AnimatePresence>
						{lines === 2 && (
							<motion.path
								variants={fillAnimationVariants}
								animate={color}
								d="m4.33 53.05 55.46-3.3-2.14-.65-55.63 3.27z"
								data-name="line2"
							/>
						)}
					</AnimatePresence>
					<g data-name="worker">
						<path
							style={{
								fill: '#b88832',
							}}
							d="m59.21 50.44-.55.82v-3.27l.55-.32z"
						/>
						<path
							style={{
								fill: '#b79268',
							}}
							d="m59.26 50.38-.56.82v-3.23l.56-.33z"
						/>
						<path
							style={{
								fill: '#9e7443',
							}}
							d="m54.56 48.66-1.1-.64v-.06l1.1.63zM54.56 48.82l-1.1-.63v-.06l1.1.63zM54.56 48.97l-1.1-.63v-.07l1.1.63zM54.56 49.79l-1.1-.63v-.11l1.1.64z"
						/>
						<path
							style={{
								fill: '#9b7045',
							}}
							d="m53.75 49.09-.14-.38-.15.21zM54.56 49.55l-.15-.37-.14.2zM54.15 49.32l-.14-.37-.15.2z"
						/>
						<path
							d="M53.82 53.49c.59.24 1.2-.42.7-.83-.72-.57-1.46-1.14-1.39-1.67.07-.53-1.25-.71-1.25-.71-.38.54-.63.8-.69 1.14-.06.34 1.93 1.79 2.63 2.07M57.76 50.94c0 .23-.22 1.34-.18 1.54a13.54 13.54 0 0 0 4.23.21c.23-.16.44-1.17-.47-1.13-.91.04-1.81-.2-1.94-.62-.13-.42-1.64 0-1.64 0z"
							style={{
								fill: '#b07e2e',
							}}
						/>
						<path
							d="M53.87 53.32c.54.33 1.27-.45.76-.85-.71-.58-1.45-1.15-1.39-1.68.06-.53-1.24-.71-1.24-.71-.38.55-.72.86-.72 1.2 0 .34 1.94 1.65 2.59 2M57.76 50.81a12.51 12.51 0 0 0-.17 1.44 16.38 16.38 0 0 0 4.31.28c.21-.17.35-1.14-.56-1.1-.91.04-1.81-.2-1.94-.62-.13-.42-1.64 0-1.64 0zM57.72 30.51A3 3 0 0 1 60 31.69l1 1.78h-2.4z"
							style={{
								fill: '#e29425',
							}}
						/>
						<path
							d="M56.63 40.07c0 .71-.33 6-.33 6.45 0 .63-2.38 4.47-2.6 4.72-.22.25-1.87-.73-1.91-1-.04-.27 2-3.34 2.16-4.43.08-.46-.29-2.2-.33-3.52 0-1.49-.23-3.24-.23-3.24z"
							style={{
								fill: '#7d807f',
							}}
						/>
						<path
							d="M58.33 38.61c.15.51 1.61 6.13 1.59 6.79-.02.66.08 5.49-.31 5.6a5.28 5.28 0 0 1-1.86 0c-.37-.07-.13-5-.13-5l-1.55-6.1z"
							style={{
								fill: '#606462',
							}}
						/>
						<path
							d="M53.48 41.18v1.07c0 .3 2.77-.21 3.74-.69.97-.48 2.33-1 2.33-1l-1.16-1.35z"
							style={{
								fill: '#939997',
							}}
						/>
						<path
							d="M59.85 33.86c-.14-.39-1.19-3.35-2-3.35a7.82 7.82 0 0 0-2.9.36 4.81 4.81 0 0 0-2.19 2c-.17.23.78 8.34.72 8.62-.1.45 4.87-.95 4.86-1.41-.01-.46 1.71-5.66 1.51-6.22z"
							style={{
								fill: '#7d807f',
							}}
						/>
						<path
							d="M57.34 30.5a7 7 0 0 0-1.41 0 3.28 3.28 0 0 0-1.79.87c-.14.25 2.09 2.53 2.86 2.33.77-.2.53-2.88.34-3.2z"
							style={{
								fill: '#f9a21d',
							}}
						/>
						<path
							d="M57 30.52a9.29 9.29 0 0 1-1 .16c-.43 0-1.21.11-1.3.26-.09.15.64 1.93 1.73 1.58 1.09-.35.67-1.79.57-2z"
							style={{
								fill: '#e8e7e7',
							}}
						/>
						<path
							style={{
								fill: '#f7c26b',
							}}
							d="m60.53 35.6 5.89-3.4-4.52-2.61-5.89 3.4z"
						/>
						<path
							style={{
								fill: '#d3a55c',
							}}
							d="m63.08 34.13.69-.4-4.51-2.61-.7.4z"
						/>
						<path
							style={{
								fill: '#d3b183',
							}}
							d="m63.13 34.1.69-.4-4.52-2.61-.69.4z"
						/>
						<path
							style={{
								fill: '#f5b444',
							}}
							d="m66.42 39-5.89 3.4v-6.8l5.89-3.4z"
						/>
						<path
							style={{
								fill: '#b88832',
							}}
							d="m63.76 37.17-.69 1.02v-4.06l.69-.4z"
						/>
						<path
							d="m61.9 39.81-1 .58v1.38l1-.58zm-.94.62.87-.5v1.22l-.87.5z"
							style={{
								fill: '#9e7443',
							}}
						/>
						<path
							style={{
								fill: '#9e7443',
							}}
							d="m61.1 40.99.1-.05v.33l.04-.03v-.33l.1-.06-.12-.44zM61.57 40.21l-.12.58.1-.05v.32l.04-.02v-.33l.1-.05zM61.69 41.12l-.59.34v-.07l.59-.34zM63.13 39.1l-1 .57v1.39l1-.58zm-.94.61.87-.5v1.23l-.87.5z"
						/>
						<path
							style={{
								fill: '#9e7443',
							}}
							d="m62.95 40.39-.27.15v-.06l.27-.16zM62.81 40.17c-.07 0-.14 0-.14-.11v-.47l.29-.17v.48a.34.34 0 0 1-.15.27z"
						/>
						<path
							style={{
								fill: '#9e7443',
							}}
							d="m62.85 40.45-.07.04v-.38l.07-.04zM62.59 40.5l-.1.06v-.19a.34.34 0 0 0 .11-.24v-.53l-.32.19v.53c0 .08 0 .12.1.11v.19l-.1.06v.12l.31-.18zm-.26.21.1-.06v-.28s-.09 0-.09-.09v-.47l.24-.14v.47a.26.26 0 0 1-.09.19v.27l.1-.05-.22.12zM64.36 38.39l-1 .57v1.38l1-.57zm-.93.61.86-.5v1.23l-.86.5z"
						/>
						<path
							d="M63.78 40h-.09c-.02 0 0 0 0-.1h.06v.06a.2.2 0 0 0 0-.05v-.52h.06v.52a.2.2 0 0 1 0 .11.2.2 0 0 1-.03-.02ZM64.22 39.05a.22.22 0 0 0-.36-.16.83.83 0 0 0-.36.58Z"
							style={{
								fill: '#9e7443',
							}}
						/>
						<path
							style={{
								fill: '#b79268',
							}}
							d="m63.82 37.1-.69 1.02V34.1l.69-.4z"
						/>
						<path
							style={{
								fill: '#c49139',
							}}
							d="m60.53 42.4-4.52-2.61v-6.8l4.52 2.61z"
						/>
						<path
							style={{
								fill: '#9e7443',
							}}
							d="m58.15 36.76-1.69-.98v-1.95l1.69.98z"
						/>
						<path
							style={{
								fill: '#e9e9e9',
							}}
							d="m58.14 36.72-1.67-.96v-1.92l1.67.96z"
						/>
						<path
							style={{
								fill: '#9e7443',
							}}
							d="m57.98 34.96-1.35-.79v-.08l1.35.79zM57.98 35.16l-1.35-.78v-.08l1.35.78zM57.98 35.34l-1.35-.78v-.08l1.35.78zM57.98 36.37l-1.35-.79v-.13l1.35.78z"
						/>
						<path
							style={{
								fill: '#9b7045',
							}}
							d="m56.98 35.49-.18-.46-.17.25zM57.98 36.07l-.18-.47-.17.26zM57.48 35.78l-.17-.46-.18.25z"
						/>
						<path
							d="M56.94 29.47a4.77 4.77 0 0 0 0 1.85c0 .43.06.85-.53 1-.77.23-1.27-.84-1.41-1.13a28.05 28.05 0 0 1-.3-2.9z"
							style={{
								fill: '#e6c49d',
							}}
						/>
						<path
							d="M58.11 26.19c.1 1.65 0 3.76-.74 4.09a2.31 2.31 0 0 1-2.37-.84 5.35 5.35 0 0 1-.9-2c-.77-3.01 4.01-1.25 4.01-1.25z"
							style={{
								fill: '#f6d3b1',
							}}
						/>
						<path
							d="M56.12 27.25a3.89 3.89 0 0 1-.11.86c0 .06-.45.28-.51.15-.06-.13-.19-.41-.43-.22-.24.19.15 1.55.06 1.55a4.69 4.69 0 0 1-1-1.9c.02-.51 1.99-.44 1.99-.44z"
							style={{
								fill: '#b79268',
							}}
						/>
						<path
							d="M55.56 27.6a9.47 9.47 0 0 1-.56-2.19 1.18 1.18 0 0 1 .43-.27 3.1 3.1 0 0 1 2.22.23c.83.54.87 2.06.54 2-.33-.06-2.56.53-2.63.23z"
							style={{
								fill: '#f9a21d',
							}}
						/>
						<path
							d="M54 26.21a2 2 0 0 0 .2 1.79s1.49-.06 1.56-.33a7.85 7.85 0 0 0-.26-1.28c-.11-.53 0-1.23-.12-1.21A2.27 2.27 0 0 0 54 26.21Z"
							style={{
								fill: '#d48b28',
							}}
						/>
						<path
							d="M58.24 26.55c.47.12 1.89.69 1.75.84-.93 1-4.54.52-4.49.4a2.82 2.82 0 0 1 1.13-.85 3.57 3.57 0 0 1 1.61-.39z"
							style={{
								fill: '#d48b28',
							}}
						/>
						<path
							d="M53.56 31.86a3.26 3.26 0 0 0-1.35 1.88 24.92 24.92 0 0 0-.56 4.87c-.06 1 .76.8.87.76.11-.04.39-.81.68-1 .61-.38.93-2.58.94-3.91 0-.91-.34-2.84-.58-2.6z"
							style={{
								fill: '#f9a21d',
							}}
						/>
						<path
							d="M53.47 38.18s2.21 1 2.54 1.19c.33.19 1.19-.41 1.29-.13.1.28-.4.31-.67.47-.27.16-.09.39.11.51l1.24.71s-1.27.23-1.78-.09-.68-.84-1.14-.84a12 12 0 0 1-2.74-.65c-.16-.17.35-1.12 1.15-1.17z"
							style={{
								fill: '#e6c49d',
							}}
						/>
						<path
							d="M53.67 38.27c-.11-.08-.42-.35-.58-.3a1.86 1.86 0 0 0-.8.7 1.21 1.21 0 0 0-.12.75 3.49 3.49 0 0 1 .57.18c.11-.08.06-.56.35-.86.29-.3.64-.42.58-.47z"
							style={{
								fill: '#f8b244',
							}}
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export default ResultsVirtualLines
